import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { gofor } from '@fiverr-private/futile/lib/gofor';
import { I18n } from '@fiverr-private/fiverr_context';

import './style.scss';

export const Online = () => (
    <div className={classNames('status', 'online-indicator')}>
        <i className="fa fa-circle"/>
        <I18n k={'general.online'}/>
    </div>
);

export const Vacation = () => (
    <div className={classNames('status', 'ooo-indicator')}>
        <I18n k={'gig_page_perseus.seller_card.out_of_office'}/>
    </div>
);

class Status extends Component {
    constructor() {
        super();

        this.state = {
            isOnline: false
        };
    }

    componentDidMount() {
        const { requestContext, pathfinderWrapper } = this.context;
        const { username } = requestContext.params;
        const url = pathfinderWrapper.pathfinder('is_online', { username });

        gofor(url)
            .then((response) => response.json())
            .then(({ is_online }) => {
                this.setState({
                    isOnline: is_online
                });
            });
    }

    render() {
        const { isOnVacation } = this.context.general;
        const { isOnline } = this.state;

        if (isOnVacation) {
            return <Vacation/>;
        } else if (isOnline) {
            return <Online/>;
        } else {
            return null;
        }
    }
}

Status.contextTypes = {
    general: PropTypes.object,
    requestContext: PropTypes.object,
    pathfinderWrapper: PropTypes.object
};

export default Status;
